<!--Sub Header-->
<router-outlet>
<div *ngIf="selectedElement.type != 'PRE' && selectedElement.type != 'POST'">
    <div>
        <!-- Web View-->
        <div class="row first-section">
            <div ngbDropdown class="col-lg-6 col-md-7 pd-l5 col-sm-12">
                <button type="button" class="btn btn-outline-primary left-dropdown capitalize font-26"
                    id="dropdownBasic2" ngbDropdownToggle
                    *ngIf="filterOnlyCoursesAndMasterClasses(elements).length > 0">
                    {{selectedElement?.title?.toLowerCase()}}
                    <span *ngIf="selectedElement?.type === 'MASTERCLASS'"><i
                            class="fa fa-video-camera iconMiddle"></i></span>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="drop-down-values">
                    <button *ngFor="let element of filterOnlyCoursesAndMasterClasses(elements)"
                        (click)="onElementChange(element.title, true)" ngbDropdownItem>
                        <span class="capitalize">{{element?.title?.toLowerCase()}}</span>
                        <span *ngIf="element.type === 'MASTERCLASS'"><i
                                class="fa fa-video-camera iconMiddle"></i></span>
                    </button>
                </div>
            </div>

            <div ngbDropdown class="text-right col-lg-6 col-md-5 col-sm-12"
                *ngIf="selectedElement?.type === 'MASTERCLASS' && filteredGroups != undefined && filteredGroups.length > 1">
                <!-- <button type="button" class="btn btn-outline-primary left-dropdown placeholder-button font-18"
                    *ngIf="filteredGroups != undefined && filteredGroups.length === 1">{{selectedGroup?.mc_usergroup}}</button> -->
                <button type="button"
                    class="btn btn-outline-primary left-dropdown font-18" id="dropdownBasic1" ngbDropdownToggle>
                    User Group: {{selectedGroup?.mc_usergroup}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-down-values">
                    <button *ngFor="let group of filteredGroups" (click)="onGroupChange(group.mc_usergroup)"
                        ngbDropdownItem>
                        {{group.mc_usergroup}}</button>
                </div>
            </div>
        </div>
    </div>

    <!-- First Div -->
    <div class="">
        <div class="row main-content">
            <!-- <div class="col-md-12 col-lg-12 col-12 col-xs-12 col-sm-12 displayInherit"> -->
            <div class="col-md-12 col-lg-6 col-12 col-xs-12 col-sm-12 divSperationMargin">
                <div class="lableRound font-14">
                    <!-- <span style="text-transform:capitalize;">{{selectedElement?.type?.toLowerCase()}}</span> -->
                    <span style="text-transform:capitalize;" *ngIf="selectedElement?.type === 'MASTERCLASS'">
                        {{selectedElement?.title?.toLowerCase().includes('thrive live') ? 'Thrive Live' : selectedElement?.type?.toLowerCase()}}
                    </span>
                    <span style="text-transform:capitalize;" *ngIf="selectedElement?.type === 'COURSE'">
                        {{selectedElement?.title?.toLowerCase().includes('thrive master') ? 'Thrive Master' : selectedElement?.type?.toLowerCase()}}
                    </span>
                    <span style="text-transform:capitalize;" *ngIf="selectedElement?.type === 'PRE' || selectedElement?.type === 'POST'">
                        {{selectedElement?.type?.toLowerCase()}}
                    </span>
                    <span style="text-transform:capitalize;" *ngIf="selectedElement?.type === 'ASSESSMENT'">
                        {{selectedElement?.title?.toLowerCase().includes('thrive drill') ? 'Thrive Drill' : selectedElement?.type?.toLowerCase()}}
                    </span>
                </div>
                <div class="d-inline mg-l10 font-20" *ngIf="selectedElement?.type === 'MASTERCLASS'">
                    <i class="fa fa-video-camera" aria-hidden="true"></i>
                </div>

                <div class="content-header">
                    <h1 class="font-46">
                        <span style="text-transform:capitalize;">{{selectedElement?.title?.toLowerCase()}}</span>
                    </h1>
                </div>

                <div class="lableRoundWhiteBg">
                    Unlock Date: {{selectedElement?.type === 'MASTERCLASS' && filteredGroups != undefined && filteredGroups.length > 1 ?  groupMetrics?.startDateString : selectedElement?.startDateString}}
                </div>
                <div class="text-Holder divSperationMargin mg-t10">

                    <div class="font-14">
                        {{selectedElement?.description}}
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-lg-6 col-12 col-xs-12 col-sm-12 programImage-holder">
                <div class="bkgImg">
                    <img class="w-100"
                        [src]="selectedElement?.thumbnail ? selectedElement.thumbnail : selectedElement?.type === 'MASTERCLASS' ? '/assets/images/masterclass-partner.jpg' : '/assets/images/course-partner.jpg'">

                </div>
            </div>
            <!-- </div> -->
        </div>
    </div>

    <!-- Second Div (About Master Class / Faculty & Learner Completed) -->
    <div class="row mg-t20" *ngIf="selectedElement?.type != 'ASSESSMENT'">
        <div class="col-md-12 col-12 col-xs-12 col-sm-12"
            [ngClass]="selectedElement?.type === 'MASTERCLASS' && selectedGroup?.faculty_name === null ? 'col-lg-12' : 'col-lg-12'">
            <!-- <div> -->
            <!-- <div class=""> -->
            <!-- <div class="row"> -->
            <div class="card mg-auto pd-responsive10">
                <div class="r-box-body program-rating">

                    <div class="r-box-body" *ngIf="selectedElement?.type === 'COURSE' || selectedElement === ''">
                        <div class="rating-container mg-b10">
                            <app-star-rating
                                [starRating]='selectedElement?.totalRatings > 0 ? getAvg(selectedElement?.totalRatings,selectedElement?.totalRatingCount) : 0'>
                            </app-star-rating>
                            <p class="font-12">({{selectedElement?.totalRatingCount}} Ratings)</p>
                        </div>
                        <div class="font-color-4a">
                            <p class="rating-list mg-b10 row">
                                <span class="col-2 rating-value">5 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="selectedElement?.totalRatingCount"
                                    [progressValue]="selectedElement?.ratingsHistogram?.length > 4 ? selectedElement.ratingsHistogram[4] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{selectedElement?.ratingsHistogram?.length > 4 ?
                                    selectedElement.ratingsHistogram[4] : 0}}</span>
                            </p>
                            <p class="rating-list mg-b10 row">
                                <span class="col-2 rating-value">4 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="selectedElement?.totalRatingCount"
                                    [progressValue]="selectedElement?.ratingsHistogram?.length > 4 ? selectedElement.ratingsHistogram[3] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{selectedElement?.ratingsHistogram?.length > 4 ?
                                    selectedElement.ratingsHistogram[3] : 0}}</span>
                            </p>
                            <p class="rating-list mg-b10 row">
                                <span class="col-2 rating-value">3 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="selectedElement?.totalRatingCount"
                                    [progressValue]="selectedElement?.ratingsHistogram?.length > 4 ? selectedElement.ratingsHistogram[2] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{selectedElement?.ratingsHistogram?.length > 4 ?
                                    selectedElement.ratingsHistogram[2] : 0}}</span>
                            </p>
                            <p class="rating-list mg-b10 row">
                                <span class="col-2 rating-value">2 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="selectedElement?.totalRatingCount"
                                    [progressValue]="selectedElement?.ratingsHistogram?.length > 4 ? selectedElement.ratingsHistogram[1] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{selectedElement?.ratingsHistogram?.length > 4 ?
                                    selectedElement.ratingsHistogram[1] : 0}}</span>
                            </p>
                            <p class="rating-list row mg-b5">
                                <span class="col-2 rating-value">1 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="selectedElement?.totalRatingCount"
                                    [progressValue]="selectedElement?.ratingsHistogram?.length > 4 ? selectedElement.ratingsHistogram[0] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{selectedElement?.ratingsHistogram?.length > 4 ?
                                    selectedElement.ratingsHistogram[0] : 0}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="r-box-body" *ngIf="selectedElement?.type === 'MASTERCLASS'">
                        <div class="rating-container mg-b10">
                            <app-star-rating
                                [starRating]='groupMetrics?.totalRatings > 0 ? getAvg(groupMetrics?.totalRatings,groupMetrics?.totalRatingCount) : 0'>
                            </app-star-rating>
                            <p class="font-12">({{groupMetrics?.totalRatingCount}} Ratings)</p>
                        </div>
                        <div>
                            <p class="rating-list mg-b10 row">
                                <span class="col-2 rating-value">5 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="groupMetrics?.totalRatingCount"
                                    [progressValue]="groupMetrics?.ratingsHistogram?.length > 4 ? groupMetrics.ratingsHistogram[4] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{groupMetrics?.ratingsHistogram?.length > 4 ?
                                    groupMetrics.ratingsHistogram[4] : 0}}</span>
                            </p>
                            <p class="rating-list mg-b10 row">
                                <span class="col-2 rating-value">4 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="groupMetrics?.totalRatingCount"
                                    [progressValue]="groupMetrics?.ratingsHistogram?.length > 4 ? groupMetrics.ratingsHistogram[3] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{groupMetrics?.ratingsHistogram?.length > 4 ?
                                    groupMetrics.ratingsHistogram[3] : 0}}</span>
                            </p>
                            <p class="rating-list mg-b10 row">
                                <span class="col-2 rating-value">3 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="groupMetrics?.totalRatingCount"
                                    [progressValue]="groupMetrics?.ratingsHistogram?.length > 4 ? groupMetrics.ratingsHistogram[2] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{groupMetrics?.ratingsHistogram?.length > 4 ?
                                    groupMetrics.ratingsHistogram[2] : 0}}</span>
                            </p>
                            <p class="rating-list mg-b10 row">
                                <span class="col-2 rating-value">2 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="groupMetrics?.totalRatingCount"
                                    [progressValue]="groupMetrics?.ratingsHistogram?.length > 4 ? groupMetrics.ratingsHistogram[1] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{groupMetrics?.ratingsHistogram?.length > 4 ?
                                    groupMetrics.ratingsHistogram[1] : 0}}</span>
                            </p>
                            <p class="rating-list row mg-b5">
                                <span class="col-2 rating-value">1 ★</span>
                                <app-progress-bar progressHeight="16px" class="col-8 pd-t5"
                                    [maxValue]="groupMetrics?.totalRatingCount"
                                    [progressValue]="groupMetrics?.ratingsHistogram?.length > 4 ? groupMetrics.ratingsHistogram[0] : 0"
                                    colorValue="upgrad" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value">{{groupMetrics?.ratingsHistogram?.length > 4 ?
                                    groupMetrics.ratingsHistogram[0] : 0}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- </div> -->
            <!-- </div> -->
            <!-- </div> -->
        </div>
    </div>
  <div class="row mg-t20" *ngIf="selectedElement?.type != 'ASSESSMENT'">
    <div class="col-md-12 col-xs-12 col-sm-12"
         [ngClass]="selectedElement?.type === 'MASTERCLASS' && selectedGroup?.faculty_name === null ? 'col-lg-12' : 'col-lg-12'">
      <div class="progress-holder card pd-responsive10"
           [ngClass]="selectedElement?.type === 'COURSE' || selectedGroup?.faculty_name != null ? 'three-div' : 'two-div'">
        <div class="marginBot text-center margin-tb-auto"
             *ngIf="selectedElement?.type === 'MASTERCLASS' && selectedGroup?.faculty_name != null">
          <ng-template #tooltip>
            <div [innerHtml]="selectedGroup?.faculty_long_bio || ' '"></div>
          </ng-template>
          <img class="mg-auto faculty-image"
               [src]="selectedGroup?.faculty_profile_pic || './assets/new-dashboard/dummy.png'"
               [ngbTooltip]="selectedGroup?.faculty_long_bio != '' ? tooltip : ''" placement="right">
          <div class="bold-text font-12 pd-t10 font-color-4a">
            Faculty: {{selectedGroup?.faculty_name || ''}}<br>
          </div>
        </div>
        <!-- <div class="marginBot text-center margin-tb-auto">
            <div class="duration-holder">
                <img src="./assets/new-dashboard/duration.png">
                <div class="font-weight-500 font-16 pd-l20 font-color-4a">
                    Duration in hours <br>
                    <span class="lh-42" *ngIf="selectedElement?.mins">{{(getAvg(selectedElement?.mins, 1, 0)/60).toFixed(1) | number}}</span>
                </div>
            </div>
        </div> -->
        <div class="marginBot mg-auto text-center">
          <div class="font-weight-500 font-16 mg-b5 font-color-4a">
            Duration in hours
          </div>
          <div class="lableRound">
            <span class="font-42">{{(getAvg(selectedElement?.mins, 1, 0)/60).toFixed(1) | number}}</span>
          </div>
        </div>
        <!-- <span class="border-span"></span> -->
        <!-- <div class="marginBot text-center circular-holder">
        <app-circular-progress titleFontWeight="500" titleFontSize="20" radius="60" [currentValue]="getCompletedAvg()" outerColor="#FFBD19" title="Learners Completed" [subTitle]="getCompletedAvg() + '%'" [subTitleSize]="38"></app-circular-progress>
    </div> -->
        <div class="marginBot mg-auto text-center">
          <div class="font-weight-500 font-16 mg-b5 font-color-4a">
            Completion
          </div>
          <div class="lableRound">
            <span class="font-42">{{getCompletedAvg()}}%</span>
          </div>
        </div>
        <div class="marginBot mg-auto text-center" *ngIf="selectedElement?.type === 'COURSE'">
          <div class="font-weight-500 font-16 mg-b5 font-color-4a">
            Average Score
          </div>
          <div class="lableRound">
                        <span class="font-42">{{getAvg(selectedElement?.totalScore, selectedElement?.completed,
                          0)}}</span>
          </div>
        </div>
        <div class="marginBot mg-auto text-center">
          <div class="font-weight-500 font-16 mg-b5 font-color-4a">
            Average Time Spent
          </div>
          <div class="lableRound average-time">
                        <span class="font-42">{{
                            avgTimeSpent?.totalTimeattendedLive || avgTimeSpent?.totalTime ? (((avgTimeSpent?.totalTimeattendedLive ? avgTimeSpent?.totalTimeattendedLive : 0) + (avgTimeSpent?.totalTime ? avgTimeSpent?.totalTime : 0)/avgTimeSpent?.count)| formateSeconds: 'HM') : '-'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- Learners Table -->
    <div class="mg-t50 mg-b50 r-box-body data-table">
        <div class="r-box-header ">
            <div class="center mg-b50 font-color-4a position-relative">
                {{this.selectedElement?.type === 'MASTERCLASS' ? 'Masterclass Attendance' : this.selectedElement?.type === 'COURSE' ? 'Course Leaderboard' : this.selectedElement?.type === 'ASSESSMENT' ? 'Assessment Tracker' : 'Assessment Tracker'}}
                <div class="table-sort">
                    <div ngbDropdown class="d-inline-block">
                        <button type="button" class="btn btn-outline-primary" id="dropdownBasic3" ngbDropdownToggle>
                            {{selectedValue ? selectedValue : 'Sort'}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3" class="drop-down-values">
                            <button *ngFor="let option of getDropDownOptions()" ngbDropdownItem
                                (click)="onSortChange(option.value, option.name)"
                                class="font-16">{{option.name}}</button>

                        </div>
                    </div>

                </div>
            </div>

        </div>

        <!-- Table -->
        <div class="scrollable">
            <table class="table table-responsive class-table">
                <thead class="font-color-4a">
                    <th class="th-width-200">Learner's Name</th>
                    <!-- <th>Department</th> -->
                    <th>Email</th>
                    <!-- <th>Manager's Email</th> -->
                    <th class="th-width-125">Completion</th>
                    <th *ngIf="selectedElement?.type === 'COURSE' && getAvg(selectedElement?.totalScore,
                    selectedElement?.completed, 0) != 'NA' && !hideScoreColumn" class="th-width-125">Score/100</th>
                    <!-- <th>Manager's Email</th> -->
                    <th class="th-width-175 review-column"
                        *ngIf="selectedElement?.type === 'MASTERCLASS' || selectedElement?.type === 'COURSE'">Review
                    </th>
                    <!-- <th class="w-20Per" *ngIf="selectedElement?.type === 'COURSE'">HabitDrills</th> -->
                    <th *ngFor="let hdcol of habitDrillColumns; let i as index" class="th-width-120">
                        {{habitDrillColumns.indexOf(hdcol) % 2 == 0 ? 'Habit Drills Completion' : 'Habit Drills Rating'}}
                        {{habitDrillColumns.indexOf(hdcol) > 2 ? habitDrillColumns.indexOf(hdcol) - 2 : ''}}</th>
                    <th class="th-width-125" *ngIf="selectedElement?.type != 'ASSESSMENT'">{{selectedElement?.type === 'COURSE' ? 'Course' : 'Masterclass'}} Rating/5
                    </th>
                    <th *ngIf="selectedElement.type == 'ASSESSMENT' " class="th-width-125">Score/100</th>
                    <th class="th-width-125">{{selectedElement.type == 'MASTERCLASS' ? 'Recording Watched Time' :'Time Spent'}}</th>
                    <th class="th-width-125" *ngIf="selectedElement.type == 'MASTERCLASS'">Session Attendance Time</th>
                </thead>
                <tbody>
                    <tr class="average-holder font-color-4a">
                        <td class="bold-text">Cohort Average</td>
                        <td></td>
                        <td class="pd-r5">
                            <app-progress-bar colorValue="success" maxValue="100" [progressValue]="(this.selectedElement?.type === 'MASTERCLASS' && this.groupMetrics?.completed === 0) || (this.selectedElement?.type === 'COURSE' && this.selectedElement?.completed === 0 && this.selectedElement?.inProgress === 0) ? 0 : getCompletedAvg()"
                                showTitle="true"></app-progress-bar>
                        </td>

                        <td class="font-14 font-weight-bold" *ngIf="selectedElement?.type === 'COURSE' && getAvg(selectedElement?.totalScore,selectedElement?.totalScoreCount, 0) != 'NA' && !hideScoreColumn">
                            <span class="pill pd-r20 w-100"
                                [ngClass]="{'grey': getAvg(selectedElement?.totalScore, selectedElement?.totalScoreCount, 0) === 'NA'}">{{getAvg(selectedElement?.totalScore,
                                selectedElement?.completed, 0)}}</span>
                        </td>
                        <td *ngFor="let hdcol of habitDrillColumns"></td>

                        <td class="font-14 pd-l40"></td>
                        <td style="min-width: 50px;" *ngIf="selectedElement?.type != 'ASSESSMENT'">{{selectedElement?.type === 'MASTERCLASS' ? groupMetrics?.totalRatings > 0 ? getAvg(groupMetrics?.totalRatings,groupMetrics?.totalRatingCount) : '-' : selectedElement?.totalRatings > 0 ? getAvg(selectedElement?.totalRatings,selectedElement?.totalRatingCount) : '-'}}</td>
                        <td style="min-width: 50px;" class="bold-text"> {{(avgTimeSpent?.totalTime != 0 && avgTimeSpent?.count !=0 ? ( avgTimeSpent?.totalTime/avgTimeSpent?.count | formateSeconds: 'hm' ) : '-')}}</td>
                        <td style="min-width: 50px;" class="bold-text" *ngIf="selectedElement.type =='MASTERCLASS'"> {{(avgTimeSpent?.totalTimeattendedLive != 0 && avgTimeSpent?.count !=0 ? ( avgTimeSpent?.totalTimeattendedLive/avgTimeSpent?.count | formateSeconds: 'hm') : '-')}}</td>
                        <!-- <td *ngIf="selectedElement?.type == 'ASSESSMENT'"></td> -->

                    </tr>
                    <tr style="height: 15px;"></tr>
                    <tr *ngFor="let learner of filteredLearners | paginate: {itemsPerPage: 10, currentPage:page, id: '1'}; let i = index"
                        class="font-color-4a">
                        <td class="bold-text">{{learner.name}}</td>
                        <td>{{learner.email}}</td>
                        <!-- <td>{{learner.Department}}</td> -->
                        <!-- <td>{{learner.manager_email || '-'}}</td> -->
                        <td>
                            <app-progress-bar colorValue="success" maxValue="100" [progressValue]="learner.progress"
                                showTitle="true"></app-progress-bar>
                        </td>
                        <td class="font-14 font-weight-bold pd-t5" *ngIf="selectedElement?.type === 'COURSE' && getAvg(selectedElement?.totalScore,
                        selectedElement?.totalScoreCount, 0) != 'NA' && !hideScoreColumn"><span
                                class="pill pd-r20 w-100" [ngClass]="{'grey': learner.score === null}">{{learner.score !== null
                                ? getRound(learner.score) : 'NA'}}</span></td>
                        <!-- <td class="font-14">{{learner.email}}</td> -->
                        <!-- <td>{{learner.ManagerEmail}}</td> -->
                        <td class="font-14"
                            *ngIf="selectedElement?.type === 'MASTERCLASS' || selectedElement?.type === 'COURSE'">
                            {{(learner.readMore) ? learner.item_review : learner.item_review | slice:0:60}} <span
                                *ngIf="!learner.readMore && learner.item_review">...</span>
                            <a href="javascript:;" *ngIf="!learner.readMore && learner.item_review"
                                (click)="learner.readMore=true">Read More</a>
                            <a href="javascript:;" *ngIf="learner.readMore && learner.item_review"
                                (click)="learner.readMore=false">Read Less</a>
                        </td>
                        <td *ngFor="let hdcol of habitDrillColumns">
                            {{learner.habitDrills[hdcol] || '-'}}
                        </td>
                        <td class="1" *ngIf="selectedElement?.type != 'ASSESSMENT'">{{learner.rating ? learner.rating : '-'}}</td>
                        <td class="3" *ngIf="selectedElement?.type == 'ASSESSMENT'">{{learner?.score ? getRound(learner?.score) :'-'}}</td>
                        <td class="2" *ngIf="selectedElement.title && learnerMap[learner?.email][selectedElement.title]">{{learnerMap[learner?.email][selectedElement.title]?.spenttime > 0 ? (learnerMap[learner?.email][selectedElement.title]?.spenttime | formateSeconds: 'hm') : '-'}}</td>
                        <td class="4" *ngIf="selectedElement.title && selectedElement.type == 'MASTERCLASS' && learnerMap[learner?.email][selectedElement.title]">{{learnerMap[learner?.email][selectedElement.title]?.attendeLiveDuration ? (learnerMap[learner?.email][selectedElement.title].attendeLiveDuration | formateSeconds: 'hm') : '-'}}</td>
                    </tr>
                </tbody>
            </table>


        </div>
        <div class="row table-button pd-l10">
            <div class="col-lg-3 col-md-4 col-sm-5 col-6">
                <button class="font-12 mg-t10 cursor-pointer" (click)="downloadReport()">Download Report</button>
            </div>
            <div class="col-lg-9 col-md-8 col-sm-7 col-6">
                <app-table-pagination (pageChange)="page = $event" id="1" maxSize="10" directionLinks="true"
                    autoHide="true" [totalListCount]="filteredLearners ? filteredLearners.length : 0">
                </app-table-pagination>
            </div>
        </div>
    </div>

    <div class="r-box-body mg-b50 habit-drill" *ngIf="selectedElement?.type === 'COURSE'">
        <div class="r-box-header" *ngIf="filteredHabitDrillResponses.length > 0">
            <div class="center mg-b50 font-color-4a position-relative">
                Habit Drills
            </div>
        </div>
        <div class="row justify-content-center mg-b40" *ngFor="let habitDrill of filteredHabitDrillResponses">
            <div class="col-lg-4 completion">
                <app-circular-progress radius="60"
                    [currentValue]="getPercent(habitDrill?.response, filteredLearners?.length)" outerColor="#FFBD19"
                    title="Completion" [subTitle]="getPercent(habitDrill?.response, filteredLearners?.length) + '%'">
                </app-circular-progress>
            </div>
            <div class="col-lg-8 text">
                <div class="mg-b30 w-100">
                    <h1>{{habitDrill.hd_title}}</h1>
                </div>
                <!-- <p class="font-color-4a" [innerHTML]="habitDrill.hd_body"></p> -->

                <div class="inner-html" [innerHTML]="readMore ? habitDrill.hd_body : (habitDrill.hd_body | slice:0:250)+'...'"></div>
                <!-- <span *ngIf="!readMore">...</span> -->
                <!-- <button type="button" class="viewmore" [id]="isReadMore ? 'viewmore': 'viewless'" (click)="showText()">
                {{ isReadMore ? 'Read More': 'Read Less' }}
            </button> -->

                <button type="button" class="viewmore" *ngIf="!readMore" (click)="readMore=true">Read More</button>
                <button type="button" class="viewless" *ngIf="readMore" (click)="readMore=false">Read Less</button>
            </div>
        </div>

    </div>
</div>
<div *ngIf="selectedElement.type === 'PRE' || selectedElement.type === 'POST'" class="learners-table-only">

    <div>
        <!-- Web View-->
        <div class="mg-t20">
            <div class="d-webkit-inline-box">
                <div ngbDropdown class="d-inline-block col-lg-6 col-mg-12 pd-l5">
                    <button type="button" class="btn btn-outline-primary left-dropdown capitalize font-26"
                        id="dropdownBasic2" ngbDropdownToggle
                        *ngIf="filterOnlyCoursesAndMasterClasses(elements).length > 0">
                        {{selectedElement?.title?.toLowerCase()}}
                        <span *ngIf="selectedElement?.type === 'MASTERCLASS'"><i
                                class="fa fa-video-camera iconMiddle"></i></span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="drop-down-values">
                        <button id="" *ngFor="let element of filterOnlyCoursesAndMasterClasses(elements)"
                            (click)="onElementChange(element.title, true)" ngbDropdownItem>
                            <span class="capitalize">{{element?.title?.toLowerCase()}}</span>
                            <span *ngIf="element.type === 'MASTERCLASS'"><i
                                    class="fa fa-video-camera iconMiddle"></i></span>
                        </button>
                    </div>
                </div>
                <!-- </div> -->
                <!-- </div> -->
            </div>

            <div class="float-right d-webkit-inline-box" *ngIf="selectedElement?.type === 'MASTERCLASS'">
                <!-- <select class="border-none">
                <option> Select User Group</option>
            </select> -->
                <div ngbDropdown class="d-inline-block col-lg-6 col-mg-12">
                    <button type="button" class="btn btn-outline-primary left-dropdown placeholder-button font-18"
                        *ngIf="filteredGroups != undefined && filteredGroups.length === 1">{{selectedGroup?.mc_usergroup}}</button>
                    <button *ngIf="filteredGroups != undefined && filteredGroups.length > 1" type="button"
                        class="btn btn-outline-primary left-dropdown font-18" id="dropdownBasic1" ngbDropdownToggle>
                        {{selectedGroup?.mc_usergroup}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-down-values">
                        <button *ngFor="let group of filteredGroups" (click)="onGroupChange(group.mc_usergroup)"
                            ngbDropdownItem>
                            {{group.mc_usergroup}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mg-t20 mg-b50">
        <div class="col-md-12 col-lg-12 col-12 col-xs-12 col-sm-12">
            <div class="bkgImg">
                <img class="w-100 desktop-banner" [src]="queryParam === 'Basecamp' ? '/assets/new-dashboard/basecamp.png' : '/assets/new-dashboard/summit.png'">
                <img class="w-100 mobile-banner" [src]="queryParam === 'Basecamp' ? '/assets/new-dashboard/basecamp-mobile.png' : '/assets/new-dashboard/summit-mobile.png'">
            </div>
        </div>
        <!-- </div> -->
    </div>
    <div class="mg-t30 mg-b30 r-box-body data-table">
        <div class="r-box-header ">
            <div class="center mg-b50 font-color-4a position-relative">
                Assessment Tracker
                <div class="table-sort">
                    <div ngbDropdown class="d-inline-block">
                        <button type="button" class="btn btn-outline-primary" id="dropdownBasic3" ngbDropdownToggle>
                            {{selectedValue ? selectedValue : 'Sort'}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3" class="drop-down-values">
                            <button *ngFor="let option of dropDownDataPrePost" ngbDropdownItem
                                (click)="onSortChange(option.value, option.name)"
                                class="font-16">{{option.name}}</button>

                        </div>
                    </div>

                </div>
            </div>

        </div>

        <div class="scrollable table-responsive">
            <table class="table">
                <thead class="font-color-4a">
                    <th class="th-width-200">Learner's Name</th>
                    <th class="th-width-200">Email</th>
                    <th class="th-width-200">Completion</th>
                    <th></th>
                    <th class="th-width-200">Self-assessment Score/100</th>
                    <th class="th-width-200">Time Spent</th>
                </thead>
                <tbody>
                    <tr class="average-holder font-color-4a">
                        <td class="bold-text">Cohort Average</td>
                        <td></td>
                        <td class="pd-r15 pd-t5">
                            <span>
                                <app-progress-bar colorValue="success" maxValue="100"
                                    [progressValue]="getAvg(selectedElement?.totalScore, selectedElement?.totalScoreCount, 0) === 'NA' ? 0 : getCompletedAvg()"
                                    showTitle="true"></app-progress-bar>
                            </span>
                        </td>
                        <td></td>
                        <td class="font-14 font-weight-bold pd-r10">
                            <span class="pill pd-r20"
                                [ngClass]="{'grey': getAvg(selectedElement?.totalScore, selectedElement?.totalScoreCount, 0) === 'NA'}">{{getAvg(selectedElement?.totalScore,
                                selectedElement?.totalScoreCount, 0)}}</span>
                        </td>
                        <td style="min-width: 50px;" class="bold-text"> {{(avgTimeSpent?.totalTime != 0 && avgTimeSpent?.count !=0 ? ( avgTimeSpent?.totalTime/avgTimeSpent?.count | formateSeconds: 'hm') : '_')}}</td>
                        <td style="min-width: 50px;" class="bold-text" *ngIf="selectedElement.type =='MASTERCLASS'"> {{(avgTimeSpent?.totalTimeattendedLive != 0 && avgTimeSpent?.count !=0 ? ( avgTimeSpent?.totalTimeattendedLive/avgTimeSpent?.count | formateSeconds: 'hm') : '_')}}</td>
                    </tr>
                    <tr style="height: 15px;"></tr>
                    <tr *ngFor="let learner of filteredLearners | paginate: {itemsPerPage: 10, currentPage:page, id: '1'}; let i = index"
                        class="font-color-4a">
                        <td class="bold-text">{{learner.name}}</td>
                        <td>{{learner.email}}</td>
                        <td class="pd-r15 pd-t5">
                            <span>
                                <app-progress-bar colorValue="success" maxValue="100"
                                    [progressValue]="learner.score !== null ? 100 : 0" showTitle="true"></app-progress-bar>
                            </span>
                        </td>
                        <td></td>
                        <td class="font-14 font-weight-bold pd-t5"><span class="pill pd-r20"
                                [ngClass]="{'grey': learner.score === null}">{{learner.score !== null
                                ? getRound(learner.score) : 'NA'}}</span></td>
                        <td *ngIf="selectedElement.title && learnerMap[learner?.email][selectedElement.title]">{{learnerMap[learner?.email][selectedElement.title]?.spenttime > 0 ? (learnerMap[learner?.email][selectedElement.title]?.spenttime | formateSeconds: 'hm') : '-'}}</td>
                        <td *ngIf="selectedElement.title && selectedElement.type == 'MASTERCLASS' && learnerMap[learner?.email][selectedElement.title]">{{learnerMap[learner?.email][selectedElement.title]?.attendeLiveDuration ? (learnerMap[learner?.email][selectedElement.title].attendeLiveDuration | formateSeconds: 'hm') : '-'}}</td>

                    </tr>
                </tbody>
            </table>


        </div>
        <div class="row table-button pd-l10">
            <div class="col-lg-3 col-md-4 col-sm-5 col-6">
                <button class="mg-r30 font-12 mg-t10 cursor-pointer" (click)="downloadReport()">Download Report</button>
            </div>
            <div class="col-lg-9 col-md-8 col-sm-7 col-6">
                <app-table-pagination (pageChange)="page = $event" id="1" maxSize="10" directionLinks="true"
                    autoHide="true" [totalListCount]="filteredLearners ? filteredLearners.length : 0">
                </app-table-pagination>
            </div>
        </div>
    </div>
</div>
</router-outlet>

